import React from "react";
import { Link } from "react-router-dom";

const CallToActiion = ({ t, i18n }) => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* Content */}
        <div className="space-y-6">
          <h2 className="text-3xl md:text-4xl font-bold text-indigo-600">
            Welcome to <span className="text-orange-500">Alpha Appliances</span>
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Your ultimate kitchen solution! A host of Kitchen Essentials such as
            Hoods/Chimney, Built-in Hobs, Hob-Cooktop Hybrids, Cooktops,
            Built-in ovens, Cooking Ranges, Dishwashers, Induction Cooktops,
            Water Purifiers, Water Geysers and other small appliances are
            brought to you by the group.
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            <span className="text-orange-500">Alpha Appliances</span> is on its
            way to reinvent the luxury kitchen space in the Country of India.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to={"contact-us"}
              state={{ message: `Inquiry for Ultimate Kitchen Solutions` }}
              className="inline-flex items-center justify-center px-8 py-4 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-lg transition-colors duration-300 transform hover:scale-105"
            >
              Inquiry Now
            </Link>
            <Link
              to={"products"}
              className="inline-flex items-center justify-center px-8 py-4 border-2 border-indigo-600 text-indigo-600 hover:bg-indigo-600 hover:text-white font-bold rounded-lg transition-colors duration-300 transform hover:scale-105"
            >
              View Products
            </Link>
          </div>
        </div>

        {/* Image */}
        <div className="relative">
          <img
            src={"img/home/3d.webp"}
            alt="Alpha Appliances Kitchen Solutions"
            className="w-full rounded-2xl shadow-xl"
          />
          <div className="absolute -bottom-4 -right-4 bg-white rounded-xl shadow-lg p-4">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              <span className="text-sm font-semibold text-gray-700">
                Premium Quality
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToActiion;
